import styled from 'styled-components'

export const EmptyDiv = styled.div`
  // width: 100%;
`
